export default () => { 
  return [
    '+ {clickId}',
    '+ {campaignId}',
    '+ {campaignName}',
    '+ {trafficSourceId}',
    '+ {trafficSourceName}',
    '+ {deviceType}',
    '+ {deviceVendor}',
    '+ {deviceModel}',
    '+ {browser}',
    '+ {browserVersion}',
    '+ {os}',
    '+ {osVersion}',
    '+ {country}',
    '+ {countryCode}',
    '+ {city}',
    '+ {region}',
    '+ {isp}',
    '+ {userAgent}',
    '+ {ip}',
    '+ {custom1}',
    '+ {custom2}',
    '+ {customN}',
    '+ {trackingDomain}',
    '+ {referrerDomain}',
    '+ {lang}',
    '+ {connectionType}',
    '+ {mobileCarrier}'
  ] 
};